var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-content"},[_c('p',{staticClass:"h2"},[_vm._v(_vm._s(_vm.$t('lk.payment_area.payments')))]),_c('p',{staticClass:"weight-700"},[_vm._v(_vm._s(_vm.$t('lk.payment_area.payments_list')))]),_c('div',{staticClass:"transaction-list"})])
}
var staticRenderFns = []

export { render, staticRenderFns }